import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLock = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.813 3.679a5.73 5.73 0 0 1 9.783 4.052v1.385a2.173 2.173 0 0 1 2.135 2.173v8.538c0 1.2-.973 2.173-2.173 2.173H6.173C4.973 22 4 21.027 4 19.827v-8.538c0-1.188.952-2.153 2.135-2.173V7.73a5.73 5.73 0 0 1 1.678-4.052m9.033 6.936H6.173a.673.673 0 0 0-.673.674v8.538c0 .372.301.673.673.673h11.385a.673.673 0 0 0 .673-.673v-8.538a.673.673 0 0 0-.673-.674h-.712m-.75-2.884v1.384H7.635V7.731a4.23 4.23 0 1 1 8.461 0m-4.192 7.827a.038.038 0 1 1-.077 0 .038.038 0 0 1 .077 0m-.039-1.462a1.462 1.462 0 1 0 0 2.923 1.462 1.462 0 0 0 0-2.923"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLock;
